<style>
</style>

<script lang="ts">
  import Banner from '../components/Banner.svelte'
  import GrowingFamily from '../components/Growing_Family.svelte'
  import IdCommitmentPartners from '../components/ID_Commitment_Partners.svelte'
  import IdCurrentProjects from '../components/ID_Current_Projects.svelte'
  import IdEvents from '../components/ID_Events.svelte'
  import IDDetails from '../components/ID_Details.svelte'
  import IdPublications from '../components/ID_Publications.svelte'
  import LibraryPlatform from '../components/Library_Platform.svelte'
  import Partners from '../components/Partners.svelte'
  import SubscribeNewsletter from '../components/Subscribe_Newsletter.svelte'
  import { Slugs } from '../config/slugs'
  import { onDestroy } from 'svelte'
  import { locale } from 'svelte-i18n'
  import { investigationPageData } from '../stores/stores'
  import { fetchInvestigationData } from '../controllers/InvestigationController'

  export const slug = Slugs.I_D
  let lang = $locale ?? String(process.env.LOCALE)
  let isBannerLoaded = false

  const unsubscribeLocale = locale.subscribe(() => {
    lang = $locale!
  })

  function setLoadedBanners() {
    isBannerLoaded = true
  }
  fetchInvestigationData(lang)

  onDestroy(() => {
    unsubscribeLocale()
  })
</script>

<section>
  <Banner on:bannerLoaded={setLoadedBanners} {slug} />
  {#if isBannerLoaded}
    <IDDetails details={$investigationPageData?.details_section} />
    <IdCommitmentPartners section={$investigationPageData?.commitment_section} />
    <IdCurrentProjects section={$investigationPageData?.projects_section} />
    <IdEvents section={$investigationPageData?.events_section} />
    <IdPublications section={$investigationPageData?.publications_section} />
    <LibraryPlatform />
    <GrowingFamily />
    <SubscribeNewsletter />
    <Partners />
  {/if}
</section>
